
export * from "./Recognizer";
export * from "./SpeechConnectionFactory";



// WEBPACK FOOTER //
// ./~/microsoft-speech-browser-sdk/src/sdk/speech.browser/Exports.ts